module.exports = __webpack_public_path__ + "static/media/add-admin-icon.a96c8f60.png";